var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("div", {
      class: ["cover", { transition: !_vm.noTransition }],
      style: { "background-color": _vm.backgroundColor },
      on: { click: _vm.close }
    }),
    _vm._v(" "),
    _c(
      "div",
      { class: ["container", _vm.position ? _vm.position : "center"] },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }